"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var formik_1 = require("formik");
var react_1 = __importDefault(require("react"));
var __1 = require("../../..");
var __2 = require("../../../..");
var enums_1 = require("../../../../types/enums");
var PsrAdviceInput = function () {
    var _a, _b, _c, _d;
    var trans = __2.useSemantics().trans;
    var _e = formik_1.useFormikContext(), errors = _e.errors, values = _e.values;
    var adviceGiven = values.project.warm_home.psr_advice;
    return (react_1.default.createElement(__1.FormControl, { errors: (_b = (_a = errors.project) === null || _a === void 0 ? void 0 : _a.warm_home) === null || _b === void 0 ? void 0 : _b.psr_advice, label: trans('project:slhh::labels.psr-advice'), showOther: adviceGiven && adviceGiven.indexOf(enums_1.BooleanOther.OTHER) > -1, other: react_1.default.createElement(__1.FormControl, { errors: (_d = (_c = errors.project) === null || _c === void 0 ? void 0 : _c.warm_home) === null || _d === void 0 ? void 0 : _d.psr_advice_other, label: trans('project:slhh::labels.psr-advice-other') },
            react_1.default.createElement(__1.TextArea, { fast: true, name: "project.warm_home.psr_advice_other", maxLength: 5000 })) },
        react_1.default.createElement(__1.Select, { width: "sm", options: {
                psr_advice: 'Provided advice about PSR',
                is_eligible: 'Identified the client as eligible',
                not_eligible: 'None (not eligible)',
                other: 'Other',
            }, name: "project.warm_home.psr_advice" })));
};
exports.default = PsrAdviceInput;
//# sourceMappingURL=PsrAdviceInput.js.map